import styles from '../globals/pages.module.scss'
import ClaimFormMailReferral from '../components/claimFormMailReferral/main'

function MakeClaimMailRefferal() {
    return (
        <div className={`${styles.pcpClaimFormContainer}`}>
            <ClaimFormMailReferral />
        </div>
    )
}

export default MakeClaimMailRefferal
